module.exports = __webpack_public_path__ + "media/svg-new/surprise-box-84d67d39.svg";